module.exports = __webpack_public_path__ + "static/media/21.6908faf9.png";